import axios from "axios";
import { store } from "../index";
import { updateSessionExpired } from "../redux/actions/appAction";
import { getCookie, getLocalStorage } from "./general";

const tokenName = `${process.env.REACT_APP_ENVIRONMENT}qdweddingadmin`;

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((request) => {
  const sessionToken = getLocalStorage(tokenName) || getCookie(tokenName);

  if (sessionToken) {
    request.headers["Authorization"] = sessionToken;
  }

  return request;
});

api.interceptors.response.use((response) => {
  const { errorCode } = response.data;

  if (errorCode === 1) {
    store.dispatch(updateSessionExpired(true));
  }

  return response;
});

// Auth APIs
export const adminLoginApi = async (payload) => {
  const result = await api.post("/admin/login", payload).catch((_) => {
    return false;
  });

  return result;
};

export const verifySessionApi = async (payload) => {
  const result = await api.post("/admin/verify", payload).catch((_) => {
    return false;
  });

  return result;
};

// Guest APIs
export const listGuestsApi = async (payload) => {
  const result = await api
    .get("/guest/list", {
      params: { ...payload },
    })
    .catch((_) => {
      return false;
    });

  return result;
};
